import * as React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'

import * as styles from './Markdown.module.scss'

type Props = {
  className?: any
  noParagraphs?: boolean
  source: any
  escapeHtml?: boolean
  readMore?: boolean
}

type MarkdownProps = {
  className: any
  disallowedTypes?: any
  noParagraphs?: boolean
  plugins: any
  source: any
  transformLinkUri: any
  linkTarget: any
  unwrapDisallowed?: boolean
  escapeHtml?: boolean
}

const linkTarget = (url = '') => {
  let returnTarget
  const localUrl = url.split('?').shift()
  const isMail = url && url.split(':')[0] === 'mailto'
  const isPhone = url && url.split(':')[0] === 'tel'

  if ((localUrl && localUrl.substr(-4, 4) === '.pdf') || isMail || isPhone) {
    returnTarget = '_blank'
  }

  return returnTarget
}

const LinkRenderer = (props: any) => {
  // Use the sanitized href from react-markdown, not the raw node.url,
  // so javascript: and similar unsafe URLs are stripped.
  const { children, href: url } = props

  const target = linkTarget(url)

  return (
    <a
      href={url}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : ''}
    >
      {children}
    </a>
  )
}

const Markdown = ({
  className = '',
  noParagraphs = false,
  source,
  escapeHtml = false,
}: Props): JSX.Element => {
  const plugins = [remarkBreaks]

  const markdownProps: MarkdownProps = {
    className,
    plugins,
    source,
    escapeHtml,
  }

  if (noParagraphs) {
    markdownProps.disallowedTypes = ['paragraph']
    markdownProps.unwrapDisallowed = true
  }

  return (
    <div className={styles.markdown}>
      <ReactMarkdown renderers={{ link: LinkRenderer }} {...markdownProps} />
    </div>
  )
}

export default Markdown
